import { useEffect, useState } from "react";

import { AppStrings } from "../../../../../../utils/constants/AppStrings";
import { buildTimeLeftTile } from "../loginStreakHistory";

const EMPTY_CELL = "-";

const SummaryTile = ({ label, value, note, tone, testId }) => {
  const toneClass = tone
    ? ` user-manager-game-pass-monthly-login-stat--${tone}`
    : "";
  return (
    <div
      className={`user-manager-game-pass-monthly-login-stat${toneClass}`}
      data-testid={testId}
    >
      <p className="user-manager-game-pass-monthly-login-stat-label">{label}</p>
      <p
        className={`user-manager-game-pass-monthly-login-stat-value${
          tone ? ` user-manager-game-pass-monthly-login-stat-value--${tone}` : ""
        }`}
        data-testid={`${testId}-value`}
      >
        {value || EMPTY_CELL}
      </p>
      {note ? (
        <p className="user-manager-game-pass-monthly-login-stat-note">{note}</p>
      ) : null}
    </div>
  );
};

const useLiveTimeLeft = (timeLeft) => {
  const windowEnd = timeLeft?.windowEnd;
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!windowEnd) return undefined;
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, [windowEnd]);

  if (!windowEnd) {
    return timeLeft || { value: "", note: "", tone: "" };
  }
  return buildTimeLeftTile({
    windowStart: timeLeft.windowStart,
    windowEnd,
    loggedInThisWindow: timeLeft.loggedInThisWindow,
    now,
  });
};

const LoginStreakSummaryStrip = ({ summary, testId = "login-streak-summary" }) => {
  const timeLeft = useLiveTimeLeft(summary?.timeLeft);

  if (!summary) return null;

  return (
    <div
      className="user-manager-game-pass-monthly-login-summary"
      data-testid={testId}
    >
      <SummaryTile
        label={AppStrings.GAME_PASS_MONTHLY_LOGIN_TIME_LEFT_IN_WINDOW}
        value={timeLeft?.value}
        note={timeLeft?.note}
        tone={timeLeft?.tone}
        testId={`${testId}-time-left`}
      />
      <SummaryTile
        label={AppStrings.GAME_PASS_MONTHLY_LOGIN_CURRENT_STREAK}
        value={summary.currentStreak?.value}
        note={summary.currentStreak?.note}
        tone={summary.currentStreak?.tone}
        testId={`${testId}-streak`}
      />
      <SummaryTile
        label={AppStrings.GAME_PASS_MONTHLY_LOGIN_FIRST_LOGIN_THIS_MONTH}
        value={summary.firstLogin?.value}
        note={summary.firstLogin?.note}
        tone={summary.firstLogin?.tone}
        testId={`${testId}-first-login`}
      />
      <SummaryTile
        label={AppStrings.GAME_PASS_MONTHLY_LOGIN_STREAKS_BROKEN}
        value={summary.streaksBroken?.value}
        note={summary.streaksBroken?.note}
        tone={summary.streaksBroken?.tone}
        testId={`${testId}-broken`}
      />
    </div>
  );
};

export default LoginStreakSummaryStrip;
